import { requestWithToken } from '../../../utilities/request';

/**
 * 社員・ゲスト画像アップロードAPI
 * @param {object} param
 */
const updateFaceImage = param => {
  return requestWithToken({
    method: 'POST',
    url: '/api/private/spot_workers/face_image_upload',
    headers: { 'content-type': 'multipart/form-data' },
    data: param,
  });
};

const FaceImageApi = {
  updateFaceImage,
};

export default FaceImageApi;



// WEBPACK FOOTER //
// ./src/services/spotWorkers/faceImage/FaceImageApi.js